<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.plus-circle-solid"></svg-vue>
          <h1 class="content-title">
            {{ $t('Buy custom product') }}
          </h1>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4">
          <router-link class="btn btn-app" to="/admin/custom-products">
            {{ $t('Back') }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <form @submit.prevent="saveCustomProduct">
        <div class="grid grid-cols-10 gap-2">
          <loading :status="loading"></loading>
          <div class="col-span-10 md:col-span-7 content-card-body">
            <div class="md:grid md:grid-cols-3 md:gap-6 px-4 py-5 sm:p-6">
              <div class="md:col-span-1">
                <h3 class="form-description-head">
                  {{ $t('Customer information') }}
                </h3>
                <p class="form-description-text">{{ $t('Fill up required information') }}.</p>
              </div>
              <div class="mt-5 md:mt-0 md:col-span-2">
                <div class="grid grid-cols-3 gap-6">
                  <div class="col-span-3">
                    <div class="flex justify-between">
                      <label class="form-label" for="full_name">{{ $t('Full name') }}</label>
                      <button @click.prevent="moreOptions = !moreOptions">{{ $t('options') }}</button>
                    </div>
                    <div class="pt-1">
                      <input :placeholder="$t('Full name')" class="form-input" id="full_name" required v-model="customProduct.full_name" />
                    </div>
                  </div>
                  <template v-if="moreOptions">
                    <div class="col-span-3">
                      <label class="form-label" for="email">{{ $t('Email') }}</label>
                      <div class="pt-1">
                        <input :placeholder="$t('Email')" type="email" class="form-input" id="email" v-model="customProduct.email" />
                      </div>
                    </div>
                    <div class="col-span-3">
                      <label class="form-label" for="phone">{{ $t('Phone') }}</label>
                      <div class="pt-1">
                        <input :placeholder="$t('Phone')" class="form-input" id="phone" v-model="customProduct.phone" />
                      </div>
                    </div>
                    <div class="col-span-3">
                      <label class="form-label" for="address">{{ $t('Address') }}</label>
                      <div class="pt-1">
                        <input :placeholder="$t('Address')" class="form-input" id="address" type="address" v-model="customProduct.address" />
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <div class="md:col-span-3">
                <div class="py-3">
                  <div class="border-t border-gray-200"></div>
                </div>
              </div>
              <div class="md:col-span-1">
                <h3 class="form-description-head">
                  {{ $t('Customer identities') }}
                </h3>
                <p class="form-description-text">{{ $t('User access and permission settings') }}.</p>
              </div>
              <div class="mt-5 md:mt-0 md:col-span-2">
                <div class="grid grid-cols-3 gap-6">
                  <div class="col-span-3">
                    <ul class="flex mb-0 list-none flex-wrap pt-3 pb-2 flex-row">
                      <li class="mb-1 last:mr-0 flex-auto text-center">
                        <a
                          class="cursor-pointer font-bold text-xs p-2 border block leading-normal rounded-l-md"
                          @click.prevent="imageTab = 1"
                          :class="{ 'text-gray-600 bg-gray-100 hover:bg-gray-200': imageTab !== 1, 'text-white bg-gray-500': imageTab === 1 }"
                        >
                          {{ $t('Capture Image') }}
                        </a>
                      </li>
                      <li class="mb-1 last:mr-0 flex-auto text-center">
                        <a
                          class="cursor-pointer font-bold text-xs p-2 border block leading-normal rounded-r-md"
                          @click.prevent="imageTab = 2"
                          :class="{ 'text-gray-600 bg-gray-100 hover:bg-gray-200': imageTab !== 2, 'text-white bg-gray-500': imageTab === 2 }"
                        >
                          {{ $t('Upload image') }}
                        </a>
                      </li>
                    </ul>

                    <div class="tab-content tab-space">
                      <div id="imageCap" :class="{ hidden: imageTab !== 1, block: imageTab === 1 }">
                        <photo-cam @catchup="imageCap($event)" :value="customProduct.image" />
                      </div>
                      <div id="imagUpload" :class="{ hidden: imageTab !== 2, block: imageTab === 2 }">
                        <image-input :remove="true" id="image-input" v-model="image"></image-input>
                      </div>
                    </div>
                    <ul class="flex mb-0 list-none flex-wrap pt-3 pb-2 flex-row">
                      <li class="mb-1 last:mr-0 flex-auto text-center">
                        <a
                          class="cursor-pointer font-bold text-xs p-2 border block leading-normal rounded-l-md"
                          @click.prevent="docTab = 1"
                          :class="{ 'text-gray-600 bg-gray-100 hover:bg-gray-200': docTab !== 1, 'text-white bg-gray-500': docTab === 1 }"
                        >
                          {{ $t('Capture Doc') }}
                        </a>
                      </li>
                      <li class="mb-1 last:mr-0 flex-auto text-center">
                        <a
                          class="cursor-pointer font-bold text-xs p-2 border block leading-normal rounded-r-md"
                          @click.prevent="docTab = 2"
                          :class="{ 'text-gray-600 bg-gray-100 hover:bg-gray-200': docTab !== 2, 'text-white bg-gray-500': docTab === 2 }"
                        >
                          {{ $t('Upload Doc') }}
                        </a>
                      </li>
                    </ul>
                    <div class="tab-content tab-space">
                      <div id="imageCap" :class="{ hidden: docTab !== 1, block: docTab === 1 }">
                        <photo-cam @catchup="docCap($event)" :value="customProduct.docs" />
                      </div>
                      <div id="docupload" :class="{ hidden: docTab !== 2, block: docTab === 2 }">
                        <image-input :remove="true" id="doc-upload" v-model="doc"></image-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-span-10 md:col-span-3 content-card-body px-4 py-5 sm:p-6">
            <div class="col-span-3">
              <label class="form-label" for="model">{{ $t('Device name and model') }}</label>
              <div class="pt-1">
                <input :placeholder="$t('Device name and model')" class="form-input" id="model" v-model="customProduct.model" />
              </div>
            </div>
            <div class="col-span-3 mt-2">
              <label class="form-label" for="imei">{{ $t('IMEI') }}</label>
              <div class="pt-1">
                <input :placeholder="$t('IMEI')" class="form-input" id="imei" v-model="customProduct.imei" />
              </div>
            </div>
            <div class="col-span-3 mt-2">
              <label class="form-label" for="serial_number">{{ $t('Serial number') }}</label>
              <div class="pt-1">
                <input :placeholder="$t('Serial number')" class="form-input" id="serial_number" v-model="customProduct.serial_number" />
              </div>
            </div>
            <div class="col-span-3 mt-2">
              <label class="form-label" for="cost">{{ $t('Cost') }}</label>
              <div class="pt-1">
                <input :placeholder="$t('Cost')" class="form-input" type="number" step="0.01" id="cost" v-model="customProduct.cost" />
              </div>
            </div>
            <div class="col-span-3 mt-2">
              <label class="form-label" for="cost">{{ $t('Price') }}</label>
              <div class="pt-1">
                <input :placeholder="$t('Price')" class="form-input" type="number" step="0.01" id="price" v-model="customProduct.price" />
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer mt-2 overflow-hidden shadow rounded-md">
          <span class="inline-flex">
            <router-link class="btn btn-app mr-4" to="/admin/custom-products">{{ $t('Cancel') }}</router-link>
            <button class="btn btn-app" :disabled="loading" type="submit">
              {{ $t('Save') }}
            </button>
          </span>
        </div>
      </form>
    </div>
  </main>
</template>
<script>
import Camera from '@/components/web-cam';

export default {
  name: 'new',
  metaInfo() {
    return {
      title: this.$i18n.t('Create custom product'),
    };
  },
  components: {
    'photo-cam': Camera,
  },
  data() {
    return {
      loading: false,
      moreOptions: false,
      imageTab: 2,
      docTab: 2,
      image: { file: null, preview: null },
      doc: { file: null, preview: null },
      customProduct: {
        sign: null,
        photo: null,
        docs: null,
        full_name: null,
        phone: null,
        email: null,
        address: null,
        model: null,
        imei: null,
        serial_number: null,
        cost: null,
        price: null,
        is_sold: false,
        qty: 1,
      },
    };
  },
  methods: {
    formHandle() {
      const form = this.customProduct;
      const formData = new FormData();
      formData.append('full_name', form.full_name);
      formData.append('email', form.email);
      formData.append('phone', form.phone);
      formData.append('address', form.address);
      formData.append('model', form.model);
      formData.append('imei', form.imei);
      formData.append('serial_number', form.serial_number);
      formData.append('cost', form.cost);
      formData.append('price', form.price);
      formData.append('is_sold', form.is_sold);

      if (this.imageTab === 2 && this.image.file) {
        formData.append('image', this.image.file);
      }

      if (this.docTab === 2 && this.doc.file) {
        formData.append('docs', this.doc.file);
      }

      if (form.image && form.image instanceof Blob) {
        formData.append('image', form.image, form.image.name);
      }

      if (form.docs && form.docs instanceof Blob) {
        formData.append('docs', form.docs, form.docs.name);
      }

      return formData;
    },
    imageCap(e) {
      this.customProduct.image = e;
    },
    docCap(e) {
      this.customProduct.docs = e;
    },
    saveCustomProduct() {
      this.loading = true;
      axios
        .post(route('custom-products.store'), this.formHandle())
        .then((response) => {
          this.loading = false;
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
          this.$router.push(`/admin/custom-products/${response.data.product}/edit`);
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
